import React, { useState, useEffect } from "react";
import Component from "../../Components";
import { useSelector } from "react-redux";
import strings from "../../utils/strings";
import { useNavigate } from "react-router-dom";

function NationalID() {
  const [selectedView, setSelectedView] = useState("nationalIdList");

  const nav = useNavigate();

  const privilege = useSelector((state) => state.verifyType.privilege);
  useEffect(() => {
    switch (true) {
      case privilege.hasNationalIdRight:
        nav(strings.navigation.nationalID);
        break;
      case privilege.hasTNCright:
        nav(strings.navigation.termsCondition);
        break;
      case privilege.hasPatientProfileRight:
        nav(strings.navigation.patientProfile);
        break;
      case privilege.hasDepartmentRight:
        nav(strings.navigation.department);
        break;
      case privilege.hasArticleRight:
        nav(strings.navigation.healthArticle);
        break;
    }
  }, [privilege]);

  return (
    <div className="article-container">
      {selectedView === "nationalIdList" && <Component.NationalIdList setSelectedView={setSelectedView} />}
      {selectedView === "nationalIdAdd" && <Component.AddNationalIdList setSelectedView={setSelectedView} />}
    </div>
  );
}

export default NationalID;
